export const NOTIFICATION_TYPES = {
  ORDERS: { type: 'order', title: 'Заказы' },
  LOYALTY: { type: 'bonus', title: 'Баллы' },
  REVIEWS: { type: 'testimonial', title: 'Отзывы' },
  QUESTIONS: { type: 'question', title: 'Ответы на вопросы' },
};
